(() => {
  'use strict';
  let config = {};
  try { config = JSON.parse(document.getElementById('ns-config').textContent); } catch { config = {}; }
  const money = value => { try { return new Intl.NumberFormat('sr-Latn-ME', {style: 'currency', currency: config.currency || 'EUR'}).format(Number(value || 0) / 100); } catch { return (Number(value || 0) / 100).toFixed(2).replace('.', ',') + ' €'; } };

  /* Korpa: cijena dostave i ukupno sa dostavom (osvježava se sa svakom promjenom korpe) */
  function updateShipping(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    const threshold = Number(config.threshold || 0);
    const cost = Number(config.shippingCost || 0);
    const free = threshold > 0 && cart.total_price >= threshold;
    const shipping = free ? 0 : cost;
    document.querySelectorAll('[data-ns-shipping-cost]').forEach(el => { el.textContent = free ? 'Dostava: besplatna' : 'Dostava: ' + money(shipping); });
    document.querySelectorAll('[data-ns-cod-total]').forEach(el => { el.textContent = 'Ukupno sa dostavom: ' + money(cart.total_price + shipping); });
  }
  document.addEventListener('cart:updated', event => updateShipping(event.detail && event.detail.cart));

  /* v13 akcija: u korpi (drawer) precrtana redovna cijena, iznos popusta po stavci i ukupna ušteda */
  function cartSale(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    const rows = document.querySelectorAll('#ns-cart-items .cart-item');
    cart.items.forEach((item, i) => {
      const row = rows[i];
      const saved = Number(item.original_line_price || 0) - Number(item.final_line_price || 0);
      if (!row || saved <= 0 || row.dataset.nsSale) return;
      row.dataset.nsSale = 'true';
      const price = row.querySelector(':scope > div > strong');
      if (price) {
        price.classList.add('ns-sale-price');
        const old = document.createElement('s');
        old.className = 'ns-old-price';
        old.textContent = money(item.original_line_price);
        price.append(' ', old);
      }
      const tag = row.querySelector('.ns-discount');
      if (tag) tag.textContent += ' · −' + money(saved);
    });
    document.querySelectorAll('[data-ns-sale-total]').forEach(el => {
      const total = Number(cart.total_discount || 0);
      el.hidden = total <= 0;
      el.innerHTML = total > 0 ? '<span>Ušteda</span><strong>−' + money(total) + '</strong>' : '';
    });
  }
  document.addEventListener('cart:updated', event => cartSale(event.detail && event.detail.cart));

  /* v13 akcija: akcijska cijena i u mini listama (preporuke u korpi i na proizvodu); spisak dolazi iz snippets/ns-dialogs.liquid */
  let akcija = {};
  try { akcija = JSON.parse(document.getElementById('ns-akcija').textContent); } catch { akcija = {}; }
  function miniSale() {
    document.querySelectorAll('.ns-mini-price:not([data-ns-sale])').forEach(el => {
      const link = el.closest('.ns-mini-body')?.querySelector('.ns-mini-title');
      const handle = ((link && link.getAttribute('href')) || '').match(/\/products\/([^/?#]+)/);
      const pct = handle ? Number(akcija[decodeURIComponent(handle[1])] || 0) : 0;
      const old = Number(el.textContent.replace(/\D/g, ''));
      el.dataset.nsSale = 'true';
      if (!pct || !old) return;
      el.classList.add('ns-sale-price');
      const was = document.createElement('s');
      was.className = 'ns-old-price';
      was.textContent = el.textContent;
      el.textContent = money(Math.floor(old * (100 - pct) / 100));
      el.append(was);
    });
  }
  if (Object.keys(akcija).length > 1 && window.MutationObserver) {
    new MutationObserver(() => { if (document.querySelector('.ns-mini-price:not([data-ns-sale])')) miniSale(); }).observe(document.body, {childList: true, subtree: true});
    miniSale();
  }

  /* Mobilna traka za kupovinu: vidljiva i dok je glavno dugme ispod ekrana */
  function stickyBelow() {
    const product = document.querySelector('[data-ns-product]');
    if (!product || !window.IntersectionObserver) return;
    const buy = product.querySelector('#ns-buy-row');
    const sticky = product.querySelector('.mobile-buy');
    if (!buy || !sticky || sticky.dataset.nsBelow) return;
    sticky.dataset.nsBelow = 'true';
    new IntersectionObserver(entries => {
      entries.forEach(entry => sticky.classList.toggle('ns-below', !entry.isIntersecting && entry.boundingClientRect.top > 0));
    }, {threshold: 0}).observe(buy);
  }
  stickyBelow();
  document.addEventListener('shopify:section:load', stickyBelow);

  /* Kolačići: kompaktna traka, Shopify Customer Privacy API (isti mehanizam koji koriste aplikacije za saglasnost) */
  function cookieBar() {
    const bar = document.getElementById('ns-cookie');
    if (!bar || bar.dataset.nsBound) return;
    bar.dataset.nsBound = 'true';
    const mode = bar.dataset.mode || 'all';
    let stored = null;
    try { stored = localStorage.getItem('ns-consent'); } catch { stored = null; }
    const setHeight = () => { document.documentElement.style.setProperty('--ns-cookie-h', bar.hidden ? '0px' : bar.offsetHeight + 'px'); document.body.classList.toggle('ns-cookie-open', !bar.hidden); };
    const show = () => { bar.hidden = false; setHeight(); };
    const hide = () => { bar.hidden = true; setHeight(); };
    const decide = () => {
      const api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api) { if (!stored) show(); return; }
      let undecided = !stored;
      try { if (typeof api.getTrackingConsent === 'function') undecided = api.getTrackingConsent() === 'no_interaction'; } catch {}
      if (!undecided) return;
      if (mode === 'regulated' && typeof api.shouldShowBanner === 'function') { try { if (!api.shouldShowBanner()) return; } catch {} }
      show();
    };
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => decide());
    } else decide();
    bar.addEventListener('click', event => {
      const button = event.target.closest('[data-ns-consent]');
      if (!button) return;
      const all = button.dataset.nsConsent === 'all';
      const consent = {analytics: all, marketing: all, preferences: all, sale_of_data: all};
      const done = () => { try { localStorage.setItem('ns-consent', all ? 'all' : 'essential'); } catch {} hide(); };
      const api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.setTrackingConsent === 'function') { try { api.setTrackingConsent(consent, done); } catch { done(); } } else done();
    });
    window.addEventListener('resize', () => { if (!bar.hidden) setHeight(); });
  }
  cookieBar();
})();
